import { select, all, call } from 'redux-saga/effects'
import { takeLatest } from 'utils/effects/effects'
import { hasDepartmentsSelector } from './selectors'
import { GET_DEPARTMENTS, getDepartments } from 'store/actions'
import client from 'services/httpClient/commonClient'
import handleRequest from 'sagas/handleRequest/handleRequest'
import { SYLIUS } from 'constants/services'
import issueTrackerService from 'services/issueTracker/issueTrackerService'

function* handleReadDepartmentListRequest() {
  const hasRecords = yield select(hasDepartmentsSelector)

  if (!hasRecords) {
    try {
      yield* handleRequest({
        requestActions: getDepartments,
        promise: call(
          client(SYLIUS, true).get,
          '/shop-api/departments?sorting[code]=asc&criteria[enabled]=true',
        ),
      })
    } catch (error) {
      issueTrackerService.captureError(error)
    }
  }
}

export default function* () {
  yield all([
    takeLatest(GET_DEPARTMENTS.REQUEST, handleReadDepartmentListRequest),
  ])
}
